<template>
  <DrField :for="$attrs.id" :label="$attrs['data-label']" :error="$attrs.error">
    <span class="relative dr-datepicker w-full bg-white block shadow p-2 sm:p-5 mb-2">
      <Datepicker
        ref="datepicker"
        v-model="selectedDate"
        v-bind="$attrs"
        :disabled-dates="disableDates"
        :class="{ 'placeholder-active': $attrs['placeholder'] }"
        input-class="mb-1 datepicker-input"
        calendar-class="datepicker-calendar"
        full-month-name
        maximum-view="month"
        data-cy="datepicker-calendar"
        @selectedDisabled="selectDisabledDate($event)"
        v-on="listeners"
      />
    </span>
    <div slot="help" class="help">
      <slot name="help" />
    </div>
  </DrField>
</template>

<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'

export default {
  components: {
    Datepicker,
  },
  props: {
    disableDates: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
      selectedDate: '',
    }
  },
  computed: {
    isToday () {
      const today = new Date()
      const selectedDate = new Date(this.selectedDate)
      if (selectedDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        return true
      }
      return false
    },
    isTomorrow (date) {
      const today = new Date()
      const tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 1)
      const selectedDate = new Date(this.selectedDate)

      if (selectedDate.setHours(0, 0, 0, 0) === tomorrow.setHours(0, 0, 0, 0)) {
        return true
      }
      return false
    },
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event),
      }
    },
  },
  watch: {
    selectedDate (val) {
      this.$emit('input', val)
    },
  },
  methods: {
    selectDisabledDate (val) {
      this.selectedDate = new Date(val.timestamp)
      this.$emit('selectDisabledDate')
    },
    showCalendar () {
      this.$refs.datepicker.showCalendar()
    },
  },
}
</script>

<style>
.datepicker-calendar.vdp-datepicker__calendar {
  @apply w-full border-0;
}

.datepicker-calendar.vdp-datepicker__calendar .cell {
  line-height: 32px;

  @apply rounded h-8;
}

/* @TODO CHANGE MEDIA TO @SCREEN */
@media (min-width: 640px) {
  .datepicker-calendar.vdp-datepicker__calendar .cell {
    line-height: 40px;

    @apply h-10;
  }
}

.datepicker-calendar.vdp-datepicker__calendar .cell.today {
  @apply text-blue-500;
}

.datepicker-calendar.vdp-datepicker__calendar .selected.disabled {
  opacity: 0.3;

  @apply bg-blue-500 !important;
}

.placeholder-active input.datepicker-input::placeholder {
  opacity: 1;
}

.day-header {
  @apply text-grey-700;
}

.datepicker-calendar.vdp-datepicker__calendar .cell:not(.blank):not(.day-header):hover {
  @apply text-white border-none bg-blue-500 opacity-50 !important;
}

.datepicker-calendar.vdp-datepicker__calendar .selected,
.datepicker-calendar.vdp-datepicker__calendar .selected:hover {
  @apply text-white border-none bg-blue-500 !important;
}

.datepicker-calendar.vdp-datepicker__calendar header .prev::after,
.datepicker-calendar.vdp-datepicker__calendar header .next::after {
  left: auto;
  width: 10px;
  height: 10px;
  border-color: #5235fc;
  border-width: 2px 2px 0 0 !important;
}

.datepicker-calendar.vdp-datepicker__calendar header .prev.disabled::after,
.datepicker-calendar.vdp-datepicker__calendar header .next.disabled::after {
  border-color: #dae1e5;
}

.datepicker-calendar.vdp-datepicker__calendar header .prev::after {
  top: 15px;
  right: calc(50% - 8px);
  transform: rotate(-135deg);
}

.datepicker-calendar.vdp-datepicker__calendar header .next::after {
  top: 15px;
  left: calc(50% - 12px);
  transform: rotate(45deg);
}
</style>
